export const valueProposition = {
  title: "Pourquoi choisir Gándara ?",
  subtitle: "Trois piliers fondamentaux qui définissent notre approche éducative",
  items: {
    montessori: {
      title: "Pédagogie Active Montessori",
      description: "Environnements préparés, matériels manipulatifs et respect des rythmes individuels d'apprentissage"
    },
    nature: {
      title: "Nature et Espaces",
      description: "Plus de 5 000 m² d'installations avec jardin, zones vertes et connexion constante avec l'environnement naturel"
    },
    community: {
      title: "Communauté Éducative",
      description: "Petits effectifs (1:12) et accompagnement proche qui permet une attention personnalisée"
    }
  }
};
